import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  currentDate: string = '';
  currentTime: string = '';
  public setCurrentDate = new BehaviorSubject<string>('');
  public setCurrentTime = new BehaviorSubject<string>('');
  public selectedCriteria = new BehaviorSubject<Record<string, any>>({});
  public icdResponseData = new BehaviorSubject<any>(null);
  public dealerCode = new BehaviorSubject<string>('');
  public dealerDesc = new BehaviorSubject<string>('');
  public isBackButtonPresent = new BehaviorSubject<boolean>(false);
  public disclaimer = new BehaviorSubject<string>('');
  public defectCodeTableData = new BehaviorSubject<any[]>([]);
  public nationalScreenSelectedValue = new BehaviorSubject<string>('');
  public regionalScreenSelectedValue = new BehaviorSubject<string>('');
  public marketScreenSelectedValue = new BehaviorSubject<string>('');
  public defectCode = new BehaviorSubject<string>('');
  public isNavIconClicked = new BehaviorSubject<boolean>(false);
  public vcdBackButtonActivated = new BehaviorSubject<boolean>(false);
  public isClearSelectionClicked = new BehaviorSubject<boolean>(false);
  public isSelectedNotInInventoryDeleted = new BehaviorSubject<boolean>(false);
  userInfo$ = new BehaviorSubject<any>(null);
  public isFloatingFilterActive = new BehaviorSubject<boolean>(false);
  public agGridFilters = new BehaviorSubject<
    { colId: string; value: string }[]
  >([]);
  // Store form state for persistence
  public savedFormState = new BehaviorSubject<{
    centerID: string | null;
    criteria: any;
    lastChangedControl: string;
    selectedDropDownPayload: string;
    disabledControls: {
      CampaignType: boolean;
      LineMake: boolean;
      EngineeringSeries: boolean;
      ModelYear: boolean;
      Location: boolean;
      VehicleCampaignStatus: boolean;
      LoanerVehicleCount: boolean;
    };
    dropdownItems: {
      CampaignTypeItems: any[];
      LineMakeItems: any[];
      EngineeringSeriesItems: any[];
      ModelYearItems: any[];
      LocationItems: any[];
      VehicleCampaignStatusItems: any[];
      LoanerVehicleCountItems: any[];
    };
    dealer: string;
    grpdesc: string;
  } | null>(null);

  constructor() {}
  updateDateAndTime() {
    this.currentDate = new Date().toLocaleDateString('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    this.currentTime = new Date().toLocaleTimeString('en-US', {
      timeZone: 'America/New_York',
    });
    this.setCurrentDate.next(this.currentDate);
    this.setCurrentTime.next(this.currentTime);
  }

  setUserInfo(data: any) {
    this.userInfo$.next(data);
  }

  getUserInfo() {
    return this.userInfo$.getValue();
  }

  cleanMojibake(text: string): string {
    return String(text ?? '')
      .replace(/[\uFFFD\u00FF\u00FD\u00FE]/g, '') // removes: � ÿ ý þ
      .replace(/\s{2,}/g, ' ') // collapse multiple spaces
      .trim();
  }
}
